import React from 'react'
import { BettingDrawerBase } from '@core/Components/BettingDrawer/Components/BettingDrawerBase'
import { ButtonBlock } from '@core/Components/Buttons/ButtonBlock'
import { NoticeBox } from '@core/Components/NoticeBox'

export const NextRaceDrawer: React.FC<
  {
    onNextRace: () => void
    onGoToMeeting: () => void
  } & BettingDrawerProps
> = ({
  isOpen,
  noticeBoxSlot,
  onNextRace,
  onGoToMeeting,
  shouldDisplayAboveTabNav = false,
  forcedZIndex,
}) => {
  return (
    <BettingDrawerBase
      isOpen={isOpen}
      testId='NextRaceDrawer'
      shouldDisplayAboveTabNav={shouldDisplayAboveTabNav}
      forcedZIndex={forcedZIndex}
      noticeBoxSlot={
        noticeBoxSlot || <NoticeBox title='Betting closed' noticeBoxType='Error' hasBorder />
      }
      secondaryButtonSlot={
        <ButtonBlock
          type='button'
          color='secondary'
          onClick={onGoToMeeting}
          data-tid-back-to-meeting-button
        >
          Back To Meeting
        </ButtonBlock>
      }
      primaryButtonSlot={
        <ButtonBlock
          type='button'
          color='primary'
          onClick={onNextRace}
          data-tid-next-race-to-jump-button
        >
          Next Race To Jump
        </ButtonBlock>
      }
    />
  )
}

// =====
// Types
// =====

type BettingDrawerProps = Pick<
  React.ComponentProps<typeof BettingDrawerBase>,
  'isOpen' | 'forcedZIndex' | 'noticeBoxSlot' | 'shouldDisplayAboveTabNav'
>
